import styled from 'styled-components';
import { Select as SelectComponent } from 'components/UI/Select';

export const UploadsWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  padding-bottom: 20px;

  &&& .ant-form-item {
    width: 100%;
  }

  &&& .ant-row .ant-form-item-row {
    width: 100%;
  }

  &&& .ant-form-item-control-input {
    width: 100%;
  }
  &&& .ant-form-vertical .ant-form-item-label {
    width: 50%;
  }
  &&& .ant-form-item-label {
    padding-right: 10px;
  }
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;

  & .ant-form-item {
    margin-bottom: 0;
  }
`;

export const Select = styled(SelectComponent)`
  &&&& {
    .ant-select-selector {
      background: var(--v3-black-0);
      border: 1px solid var(--v3-black-2);

      &:hover {
        border: 1px solid var(--v3-primary-color);
      }
    }

    .ant-select-item-option {
      text-align: left;
    }
  }
`;

export const GroupWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const FormItemLabel = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: var(--v3-text-color);
  padding-bottom: 8px;
`;
